type Image = TexImageSource;
enum ImageType {
	HTMLImageElement	= "HTMLImageElement",
	HTMLCanvasElement	= "HTMLCanvasElement",
	ImageData			= "ImageData",
};

export default class ImageWrapper {
	public content:Image;

	public static fromImage = (image:Image) => {
		let wrapper = new ImageWrapper();
		wrapper.content = image;
		return wrapper;
	}

	public static fromPNG = (png:any) => {
		let wrapper = new ImageWrapper();
		wrapper.content = {
			width: png.width,
			height: png.height,
			data: png.data
		};
		return wrapper;
	}
}